import React, { memo, useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { SnackbarType } from "../../types";

const useStyles = makeStyles(() => ({
  message: {
    whiteSpace: "pre-line",
  },
  container: {
    display: "flex",
    flexDirection: "column-reverse",
    gap: "1em"
  }
}));

type PropTypes = {
  value: SnackbarType[];
  setValue(value: SnackbarType[]): void;
};

const SnackbarComponent = ({ value, setValue }: PropTypes) => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(value.length > 0);
  }, [value.length]);

  const onClose = () => {
    setIsOpen(false);
    setValue([]);
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      autoHideDuration={5000}
      onClose={() => onClose()}
      open={isOpen}
    >
      <div className={classes.container}>
        {value.map((alert, alertIndex) =>
          <Alert
            key={alertIndex}
            classes={{
              message: classes.message,
            }}
            severity={alert?.type ? alert.type : "info"}
            elevation={6}
            onClose={() => onClose()}
          >
            {alert.message}
          </Alert>
        )}
      </div >
    </Snackbar>
  );
};

export default memo(SnackbarComponent);
